import { CourseBoardsModel } from '@descomplica/dex-models';

export default {
  courseBoardsById: (state: any, getters: any) => (courseBoardId: number) => {
    const courseBoard = state.courseBoards[courseBoardId];
    if (courseBoard) return new CourseBoardsModel(courseBoard, getters);
    return {};
  },
};
